import React, { ReactNode, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { colors, transition } from 'theme';

import Box from 'components/Box';
import { Button } from 'components/Button';
import Icon from 'components/Icon';
import StatusLabel, { Status } from 'components/StatusLabel';

const CloseButton = styled(Button)`
  color: ${colors.battleshipGrey};
  transition: all ${transition};
  &:hover {
    color: ${colors.waterBlue};
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const UserNotification = ({
  status,
  children,
  dismiss,
  ...props
}: {
  status?: Status;
  children: ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dismiss?: (...args: Array<any>) => any;
}) => {
  const ref = useRef(null);
  // Using a ref here, because we want to ensure this event handler
  // cannot fire more than once, and the `once` property is more reliable than
  // using state or a functional solution. We only want to run this when
  // the ref is ready, so no deps in the effect

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (ref && ref.current && dismiss) {
      ref.current.addEventListener('click', dismiss, {
        once: true,
      });
    }
  }, []);
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box position="relative" {...props}>
      {status && <StatusLabel status={status} />}
      <Box lineHeight={1.375} maxWidth="95%">
        {children}
      </Box>
      {dismiss && (
        <Box position="absolute" top={0} right={0}>
          <div ref={ref}>
            <CloseButton>
              <Icon name="close" width={12} height={12} fill="currentColor" />
            </CloseButton>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default UserNotification;
